/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'loading-circle';

/**
 * This is the component description.
 */
const LoadingCircle = ({
  id,
  className: userClassName,
  heightWidth,
  strokeLinecap,
  strokeWidth,
  animationDuration,
  style
  // ...otherProps
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: {
    '--height-width': heightWidth,
    '--stroke-width': strokeWidth,
    ...style
  }
  // {...otherProps}
}, /*#__PURE__*/React.createElement("svg", {
  viewBox: "25 25 50 50",
  className: "svg-circle",
  id: id,
  x: "0px",
  y: "0px",
  xmlSpace: "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  preserveAspectRatio: "xMinYMin meet",
  style: {
    '--animation-duration': `${animationDuration}s`
  }
}, /*#__PURE__*/React.createElement("circle", {
  className: "path",
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none",
  strokeLinecap: strokeLinecap,
  strokeMiterlimit: "10"
})));
LoadingCircle.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The height width of the loading div/circle
   */
  heightWidth: PropTypes.string,
  /**
   * The SVG property stroke-linecap
   */
  strokeLinecap: PropTypes.oneOf(['round', 'square', 'butt']),
  /**
   * The SVG property stroke-width
   */
  strokeWidth: PropTypes.string,
  /**
   * The duration of the animation in seconds
   */
  animationDuration: PropTypes.number,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string)
};
LoadingCircle.defaultProps = {
  strokeLinecap: 'round',
  animationDuration: 2,
  heightWidth: '1.15em'
};
export default LoadingCircle;